import {
  Box,
  Typography,
  Button,
  Container,
  Grid,
  Divider,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import Counter from "./Counter";
import talent from "../../../assets/images/talent.png";
import { useNavigate } from "react-router-dom";
import Animator from "../../../components/Aminator/Animator";

// Styled components
const StyledButton = styled(Button)(({ theme }) => ({
  backgroundColor: "#333333",
  color: "#fff",
  padding: theme.spacing(1, 3),
  borderRadius: "4px",
  textTransform: "none",
  "&:hover": {
    backgroundColor: "#222222",
  },
  marginTop: theme.spacing(3),
}));

const TalentPlacement = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Container maxWidth="lg" sx={{ my: 8 }}>
      <Grid container spacing={4} alignItems="center">
        {/* Left side - Image */}
        <Grid item xs={12} md={6}>
          <Animator variant="slide" timeout={800} delay={200}>
            <Box
              component="img"
              src={talent}
              alt="Talent placement interview"
              sx={{
                width: "100%",
                height: "auto",
                borderRadius: "8px",
                boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
              }}
            />
          </Animator>
        </Grid>

        {/* Right side - Content */}
        <Grid item xs={12} md={6}>
          <Box>
            <Animator variant="fade" timeout={800} delay={200}>
              <Typography
                variant="h3"
                component="h1"
                gutterBottom
                sx={{
                  fontFamily: "Monserrat, sans-serif",
                  fontWeight: "bold",
                  fontSize: { xs: "2rem", sm: "2.5rem", md: "2.75rem" },
                  lineHeight: 1.2,
                }}
              >
                The Home of Talent Placement and outsourcing
              </Typography>
            </Animator>

            <Divider sx={{ width: "40px", borderColor: "#999", my: 2 }} />

            <Animator variant="fade" timeout={800} delay={300}>
              <Typography
                variant="body1"
                sx={{
                  fontFamily: "Monserrat, sans-serif",
                  color: "#666",
                  mb: 2,
                  fontSize: { xs: "1rem", md: "1.1rem" },
                  lineHeight: 1.6,
                }}
              >
                We’ve built a community where talented professionals can shine.
                Our platform showcases diverse skill sets, helping each
                candidate stand out and connect with the right opportunities.
                Say goodbye to guesswork. Our intelligent matching system pairs
                your open roles with qualified candidates who not only meet your
                requirements but align with your company culture.
              </Typography>
            </Animator>

            <Animator variant="fade" timeout={800} delay={400}>
              <StyledButton
                variant="contained"
                disableElevation
                onClick={() => {
                  navigate("/talents/register");
                }}
              >
                Get Started
              </StyledButton>
            </Animator>
          </Box>
        </Grid>
      </Grid>

      {/* Stats section with animated counters */}
      <Grid
        container
        spacing={isMobile ? 4 : 8}
        sx={{ mt: 8 }}
        justifyContent="space-between"
      >
        <Grid item xs={12} sm={4} textAlign={isMobile ? "center" : "left"}>
          <Box sx={{ color: "#E25822", fontWeight: "bold", mb: 0.5 }}>
            <Counter
              end={12}
              suffix="k+"
              variant="h3"
              sx={{ color: "#E25822", fontWeight: "bold" }}
            />
          </Box>
          <Typography variant="h6" color="text.secondary">
            Clients worldwide
          </Typography>
        </Grid>

        <Grid item xs={12} sm={4} textAlign="center">
          <Box sx={{ color: "#E25822", fontWeight: "bold", mb: 0.5 }}>
            <Counter
              end={20}
              suffix="k+"
              variant="h3"
              sx={{ color: "#E25822", fontWeight: "bold" }}
            />
          </Box>
          <Typography variant="h6" color="text.secondary">
            Active resume
          </Typography>
        </Grid>

        <Grid item xs={12} sm={4} textAlign={isMobile ? "center" : "right"}>
          <Box sx={{ color: "#E25822", fontWeight: "bold", mb: 0.5 }}>
            <Counter
              end={18}
              suffix="k+"
              variant="h3"
              sx={{ color: "#E25822", fontWeight: "bold" }}
            />
          </Box>
          <Typography variant="h6" color="text.secondary">
            Companies
          </Typography>
        </Grid>
      </Grid>
    </Container>
  );
};

export default TalentPlacement;
